import { CS } from '../../service/Chat.Service'
import { CAS } from '../../service/ChatConfig.Service'
import { IChatMessage, IChatMeta } from '../../interfaces'
import { formatToChatTime } from '../../utility/date';
import { newChatProfilePic } from '../../../src/constants';

export class ChatMenuItem {
    
    public profilePicUri: string;
    public chatName: string;
    public chatLastMessagePlainText: string;
    public chatTimeStamp: string;
    public id: string
    public isActiveChat: boolean
    public isNewChat: boolean

    public buttonIsDisabled: boolean

    constructor(chatMeta: IChatMeta, activeChatId?: string ) {
        this.isNewChat = chatMeta.isNewChatPlaceholder as boolean;
        
        if(chatMeta.isNewChatPlaceholder) {
            this.id = '0';
            this.profilePicUri = newChatProfilePic
            this.chatName = CAS.localisationStrings.NewChat();
            this.chatLastMessagePlainText = '';
            this.chatTimeStamp = '';
            this.isActiveChat = false
            this.buttonIsDisabled = true;
        }

        else {
            const chatRecipient = CS.getChatRecipientFromUsers(chatMeta.users)
            this.id = String(chatMeta.id);
            this.profilePicUri = chatRecipient?.profilePicture?.uri
            this.chatName = chatRecipient?.displayName
            this.chatLastMessagePlainText = this.getLastRecipientPlainText(chatMeta.lastMessage)
            this.chatTimeStamp = chatMeta?.lastMessage?.sentAt 
                ? formatToChatTime(chatMeta.lastMessage.sentAt)
                : formatToChatTime(chatMeta.lastMessage.timestamp);
            this.isActiveChat = activeChatId === String(chatMeta.id)
            this.buttonIsDisabled = this.chatButtonShouldBeDisabled(activeChatId === String(chatMeta.id), CAS.isInSmallViewport.value);
        }

        this.openChat = this.openChat.bind(this);
        
    }

    getLastRecipientPlainText(message: IChatMessage){
        const isMe = CS.me.value.id === message.senderId

        return isMe
            ? CAS.localisationStrings.You(message?.body?.plainText)
            : message?.body?.plainText;
    }

    public openChat(){  
        if (this.id !== '0') {
            CS.hideNewChatPlaceholder();
            CAS.openChat(Number(this.id));
        }
    }

    private chatButtonShouldBeDisabled(isActiveChat: boolean, isSmallViewPort: boolean) {
        if(isActiveChat && isSmallViewPort) {
            return false;
        }
        return isActiveChat;
    }
   
}